import type * as React from 'react';

/**
 Generated using: https://react-svgr.com/playground

 How to import new SVGs:
 1. open the SVG in a text editor
 2. copy the <svg ...>  </svg> portion and replace the same section in this file, keeping the {...props}
 3. remove xmlns:xlink attribute from root svg element
 4. replace all xlink:href attributes with href
 5. replace all `fontFamily="Roboto-????, Roboto"` with matching `fontFamily="Roboto-????, Roboto, Helvetica Neue, HelveticaNeue, Helvetica, Arial, sans-serif"`
*/

const Success = () => (
  <svg
    width="128"
    height="128"
    viewBox="0 0 129 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M118.016 66.8187C117.799 66.0283 116.892 65.4552 116.082 65.7206C114.933 66.097 113.653 66.1171 112.455 65.8361C113.864 64.1093 114.434 61.9599 113.298 59.6245C112.664 58.3212 111.39 57.3607 109.934 57.2275C108.406 57.0879 107.039 57.9966 106.242 59.251C104.896 61.3705 105.403 64.1941 106.93 66.0838C106.084 66.4509 105.183 66.6797 104.27 66.7565C103.896 47.4921 85.202 31.9697 62.1805 31.9697C57.738 31.9697 53.4582 32.5516 49.4377 33.6229C46.7083 29.7073 42.1788 27.1396 37.0439 27.1396V38.9631C29.4719 43.7037 23.8624 50.5321 21.4219 58.4339H15.9777C14.057 58.4339 12.5 59.9909 12.5 61.9116V72.7728C12.5 74.6935 14.057 76.2506 15.9777 76.2506H21.4219C23.6787 83.5575 28.6449 89.9471 35.3675 94.6163V107.671H48.3204L49.9199 101.187C53.8 102.177 57.915 102.715 62.1805 102.715C67.7267 102.715 73.0171 101.805 77.8663 100.168L79.717 107.671H92.67V91.7243C99.203 85.9609 103.44 78.3509 104.165 69.9203C105.941 69.8167 107.942 69.1873 109.667 68.1691C111.9 69.2507 114.614 69.5077 116.918 68.7528C117.725 68.4885 118.249 67.6656 118.016 66.8187ZM108.625 61.7269C108.705 61.1997 109.016 60.4725 109.547 60.3588C109.997 60.2623 110.378 60.7486 110.537 61.1064C110.786 61.67 110.781 62.3007 110.554 62.912C110.358 63.4405 110.001 63.9042 109.594 64.3089C108.904 63.59 108.482 62.6769 108.625 61.7269Z"
      fill="#F470BD"
    />
    <path
      d="M33.3097 58.5436C33.1885 59.9952 31.9133 61.0737 30.4617 60.9526C29.0101 60.8314 27.9315 59.5564 28.0527 58.1048C28.1738 56.6532 29.4488 55.5746 30.9004 55.6958C32.352 55.817 33.4309 57.092 33.3097 58.5436Z"
      fill="#072462"
    />
    <path
      d="M73.1249 37.5527H54.1359V40.2034H73.1249V37.5527Z"
      fill="#0D3880"
    />
    <path
      d="M64.2786 38.6113C70.9839 38.6113 76.4197 33.1756 76.4197 26.4702C76.4197 19.7649 70.9839 14.3291 64.2786 14.3291C57.5732 14.3291 52.1375 19.7649 52.1375 26.4702C52.1375 33.1756 57.5732 38.6113 64.2786 38.6113Z"
      fill="#FDC221"
    />
    <path
      d="M64.2786 34.693C68.82 34.693 72.5015 31.0115 72.5015 26.47C72.5015 21.9286 68.82 18.2471 64.2786 18.2471C59.7372 18.2471 56.0556 21.9286 56.0556 26.47C56.0556 31.0115 59.7372 34.693 64.2786 34.693Z"
      fill="#DFA414"
    />
    <path
      d="M63.4591 27.0193H65.0982C65.5299 27.0658 65.8713 27.4071 65.9177 27.8389C65.8654 28.268 65.5273 28.6061 65.0982 28.6584H62.6395C62.1869 28.6584 61.82 29.0254 61.82 29.478C61.82 29.9305 62.1869 30.2975 62.6395 30.2975H63.4591V31.1171C63.4591 31.5696 63.826 31.9366 64.2786 31.9366C64.7312 31.9366 65.0982 31.5696 65.0982 31.1171V30.2975C65.9766 30.2975 66.7881 29.8288 67.2275 29.0682C67.6666 28.3075 67.6666 27.3702 67.2275 26.6095C66.7881 25.8489 65.9766 25.3802 65.0982 25.3802H63.459C63.0065 25.3802 62.6395 25.0132 62.6395 24.5606C62.6395 24.1081 63.0065 23.7411 63.459 23.7411H65.9177C66.3703 23.7411 66.7373 23.3741 66.7373 22.9215C66.7373 22.469 66.3703 22.102 65.9177 22.102H65.0982V21.2824C65.0982 20.8299 64.7312 20.4629 64.2786 20.4629C63.826 20.4629 63.4591 20.8299 63.4591 21.2824V22.102C62.5806 22.102 61.7691 22.5707 61.3297 23.3313C60.8907 24.092 60.8907 25.0293 61.3297 25.79C61.7691 26.5506 62.5806 27.0193 63.4591 27.0193Z"
      fill="white"
    />
    <path
      d="M33.666 74.968C32.71 74.968 31.7603 74.7458 30.8804 74.3059C30.3862 74.0588 30.186 73.4582 30.4331 72.9641C30.6802 72.47 31.2798 72.2693 31.7749 72.5168C32.7881 73.0241 33.9395 73.1067 35.0132 72.7473C36.0884 72.3889 36.9595 71.6335 37.4663 70.6199C37.7134 70.1262 38.3135 69.9245 38.8081 70.1726C39.3023 70.4197 39.5025 71.0203 39.2554 71.5144C38.5093 73.0056 37.2276 74.1174 35.646 74.6448C34.9976 74.8606 34.3301 74.968 33.666 74.968Z"
      fill="#E60278"
    />
  </svg>
);

export { Success };
